import Vue from 'vue'

const STORAGE_KEY = 'sbl_locale'

export const langState = Vue.observable({
  locale: localStorage.getItem(STORAGE_KEY) || 'zh'
})

export const messages = {
  zh: {
    common: {
      home: '首页',
      about: '企业介绍',
      profile: '公司简介',
      structure: '组织架构',
      culture: '企业文化',
      history: '企业历程',
      business: '业务介绍',
      honors: '荣誉资质',
      qualification: '资质体系',
      awards: '荣誉奖项',
      party: '党建引领',
      news: '新闻中心',
      cases: '工程案例',
      debugCases: '典型案例',
      operationCases: '工程业绩',
      enterprise: '企业文化',
      stars: '文化大纲',
      staff: '社会活动',
      contact: '联系我们',
      mail: '企业邮箱',
      details: '了解详情',
      viewDetail: '查看详情',
      readMore: '阅读全文',
      learnMore: '了解更多',
      address: '地址',
      phone: '电话',
      fax: '传真',
      email: '邮箱',
      companyName: '公司名称',
      contactInfo: '联系方式',
      leader: '负责人',
      publishedAt: '发布时间'
    },
    party: {
      tag: 'PARTY BUILDING',
      title: '党建引领',
      intro: '坚持党建引领发展，把组织优势转化为企业高质量发展的内生动力。',
      empty: '暂无党建引领内容'
    },
    header: {
      englishName: 'SENBOLE POWER',
      langToggle: 'EN'
    },
    home: {
      heroTitle: '专注电力工程服务',
      heroHighlight: '一站式综合服务平台',
      heroIntro: '山东盛博莱电力工程有限公司成立于2020年，主要从事电力技术咨询、电力调试、电力试验、电力检修、电力维护、培训、电厂托管运营、售电交易、绿电交易等业务。',
      aboutCta: '了解我们',
      contactCta: '联系我们',
      aboutTag: 'ABOUT US',
      aboutTitle: '关于我们',
      aboutSummary: '打造电力行业一站式综合服务平台',
      servicesTag: 'SERVICES',
      servicesTitle: '核心业务',
      serviceSubtitle: '聚天下英才，创智慧未来；铸造智慧电力，开创清洁能源',
      casesTag: 'CASES',
      casesTitle: '工程案例',
      newsTag: 'NEWS',
      newsTitle: '新闻动态',
      cultureTag: 'CULTURE',
      cultureTitle: '企业文化',
      contactBlockTitle: '携手盛博莱，共创智慧电力未来',
      contactBlockText: '期待与您在电力工程调试、运维、检修、试验及综合能源服务领域展开合作。',
      statsFounded: '公司成立',
      statsEmployees: '现有员工',
      statsTitles: '持证人员',
      statsPatents: '技术专利',
      serviceDebug: '电力调试',
      serviceDebugDesc: '大机组、生物质、垃圾发电、燃机、光伏、风电等调试服务',
      serviceTest: '电力试验',
      serviceTestDesc: '性能试验、热力试验、保护定值计算、设备健康检测',
      serviceMaintain: '检修维护',
      serviceMaintainDesc: '火电、新能源、垃圾发电、分布式能源设备检修维护',
      serviceTrade: '购售电服务',
      serviceTradeDesc: '电力交易代理、绿电咨询、碳排放权咨询与用电预测分析',
      cultureStarsDesc: '梳理文化理念，凝聚发展共识',
      cultureStaffDesc: '记录社会活动，展现企业担当'
    },
    about: {
      structureIntro: '公司设有总经理办公室、综合管理部、财务管理部、市场开发部、工程技术部、安全质量部、项目管理部、人力资源部等职能部门，形成了科学高效的管理体系。'
    },
    cases: {
      debugTag: '典型案例',
      operationTag: '工程业绩',
      allCategory: '全部'
    },
    footer: {
      quickLinks: '快速链接',
      serviceAreas: '业务领域',
      debug: '专业调试',
      operation: '运行维护',
      consulting: '技术咨询',
      copyrightPrefix: '版权所有'
    },
    mail: {
      title: '企业邮箱',
      heading: '企业邮箱登录',
      text: '点击下方按钮联系企业邮箱',
      button: '邮箱登录入口'
    },
    map: {
      location: '地图位置',
      waitConfig: '请在后台填写地图经纬度，或配置高德地图 Key 后按地址定位。',
      loadError: '地图加载失败，请检查高德地图 Key 配置。',
      noAddress: '请在后台填写公司地址或地图经纬度。',
      invalidPoint: '定位坐标异常，请在后台填写准确的地图经纬度。'
    }
  },
  en: {
    common: {
      home: 'Home',
      about: 'About',
      profile: 'Profile',
      structure: 'Organization',
      culture: 'Culture',
      history: 'History',
      business: 'Business',
      honors: 'Qualifications',
      qualification: 'Qualification System',
      awards: 'Honors & Awards',
      party: 'Party Building',
      news: 'News',
      cases: 'Projects',
      debugCases: 'Typical Cases',
      operationCases: 'Project Performance',
      enterprise: 'Culture',
      stars: 'Culture Outline',
      staff: 'Social Activities',
      contact: 'Contact',
      mail: 'Email',
      details: 'Learn More',
      viewDetail: 'View Details',
      readMore: 'Read More',
      learnMore: 'Learn More',
      address: 'Address',
      phone: 'Tel',
      fax: 'Fax',
      email: 'Email',
      companyName: 'Company',
      contactInfo: 'Contact Information',
      leader: 'Leader',
      publishedAt: 'Published'
    },
    party: {
      tag: 'PARTY BUILDING',
      title: 'Party Building',
      intro: 'Strengthening development through Party building and turning organizational strength into sustainable growth.',
      empty: 'No party building articles yet'
    },
    header: {
      englishName: 'SENBOLE POWER',
      langToggle: '中文'
    },
    home: {
      heroTitle: 'Power Engineering Services',
      heroHighlight: 'Integrated Service Platform',
      heroIntro: 'Shandong Senbole Power Engineering Co., Ltd. provides power technical consulting, commissioning, testing, overhaul, maintenance, training, plant operation outsourcing, power trading and green power consulting services.',
      aboutCta: 'About Us',
      contactCta: 'Contact Us',
      aboutTag: 'ABOUT US',
      aboutTitle: 'About Us',
      aboutSummary: 'Building an integrated service platform for the power industry',
      servicesTag: 'SERVICES',
      servicesTitle: 'Core Services',
      serviceSubtitle: 'Gather talents, create a smart future; build smart power and clean energy',
      casesTag: 'CASES',
      casesTitle: 'Project Cases',
      newsTag: 'NEWS',
      newsTitle: 'News',
      cultureTag: 'CULTURE',
      cultureTitle: 'Culture',
      contactBlockTitle: 'Work With Senbole For A Smarter Power Future',
      contactBlockText: 'We look forward to cooperation in power commissioning, O&M, maintenance, testing and integrated energy services.',
      statsFounded: 'Founded',
      statsEmployees: 'Employees',
      statsTitles: 'Certified Staff',
      statsPatents: 'Patents',
      serviceDebug: 'Power Commissioning',
      serviceDebugDesc: 'Commissioning services for large units, biomass, waste-to-energy, gas turbine, PV and wind projects',
      serviceTest: 'Power Testing',
      serviceTestDesc: 'Performance tests, thermal tests, protection setting calculation and equipment health inspection',
      serviceMaintain: 'Maintenance',
      serviceMaintainDesc: 'Overhaul and maintenance for thermal power, new energy, waste-to-energy and distributed energy facilities',
      serviceTrade: 'Power Trading',
      serviceTradeDesc: 'Power trading agency, green power consulting, carbon consulting and consumption forecasting',
      cultureStarsDesc: 'Culture values and shared principles',
      cultureStaffDesc: 'Social activities and corporate responsibility'
    },
    about: {
      structureIntro: 'The company has established functional departments including the general manager office, administration, finance, market development, engineering technology, safety and quality, project management and human resources, forming an efficient management system.'
    },
    cases: {
      debugTag: 'Typical Case',
      operationTag: 'Performance',
      allCategory: 'All'
    },
    footer: {
      quickLinks: 'Quick Links',
      serviceAreas: 'Services',
      debug: 'Commissioning',
      operation: 'Operation & Maintenance',
      consulting: 'Consulting',
      copyrightPrefix: 'Copyright'
    },
    mail: {
      title: 'Email',
      heading: 'Corporate Email',
      text: 'Click the button below to contact the corporate mailbox.',
      button: 'Email Entry'
    },
    map: {
      location: 'Map Location',
      waitConfig: 'Please fill in coordinates in the admin panel, or configure AMap Key to locate by address.',
      loadError: 'Map loading failed. Please check the AMap Key configuration.',
      noAddress: 'Please fill in the company address or coordinates in the admin panel.',
      invalidPoint: 'The located coordinate is abnormal. Please fill in accurate coordinates in the admin panel.'
    }
  }
}

export function setLocale(locale) {
  langState.locale = locale === 'en' ? 'en' : 'zh'
  localStorage.setItem(STORAGE_KEY, langState.locale)
}

export function toggleLocale() {
  setLocale(langState.locale === 'zh' ? 'en' : 'zh')
}

export function translate(path) {
  const value = path.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), messages[langState.locale])
  if (value !== undefined) {
    return value
  }
  return path.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), messages.zh) || path
}
